import type { UnitSystem } from "../../../renderer/src/unit-system";
export { resolveUnitSystem, type UnitSystem } from "../../../renderer/src/unit-system";

const KILOMETERS_PER_MILE = 1.609344;
const METERS_PER_FOOT = 0.3048;

/** Converts display values while preserving metric source data and film timing. */
export function measurementUnits(system: UnitSystem) {
  const imperial = system === "imperial";
  return {
    distanceUnit: imperial ? "mi" : "km",
    speedUnit: imperial ? "mph" : "km/h",
    elevationUnit: imperial ? "ft" : "m",
    elevationName: imperial ? "feet" : "meters",
    paceUnit: imperial ? "sec/mi" : "sec/km",
    distance: (kilometers: number) => imperial ? kilometers / KILOMETERS_PER_MILE : kilometers,
    speed: (kilometersPerHour: number) => imperial ? kilometersPerHour / KILOMETERS_PER_MILE : kilometersPerHour,
    elevation: (meters: number) => imperial ? meters / METERS_PER_FOOT : meters,
    pace: (secondsPerKilometer: number) => imperial ? secondsPerKilometer * KILOMETERS_PER_MILE : secondsPerKilometer,
  };
}
